import type { AlgoliaEventItem } from '~/composables/types/algolia'
import type { EventDescription } from '~/composables/types/event'
import { algoliaEventGetters } from '~/utils/algoliaEventGetters'
import { eventGetters } from '~/utils/eventGetters'

const isEventDescription = (
  data: AlgoliaEventItem | EventDescription
): data is EventDescription => {
  return (
    (data as EventDescription).object === 'EventMetaData' ||
    !!(data as EventDescription).supplier?.data
  )
}

export const parseKftEventToGtmItemListItem = (
  data: AlgoliaEventItem | EventDescription
) => {
  // Handle EventDescription (from API, e.g., kits)
  if (isEventDescription(data)) {
    const eventTitle = eventGetters.getTitle(data)
    const eventId = eventGetters.getId(data)
    const partnerName = eventGetters.getSupplierName(data) || ''
    const category = eventGetters.getMainCategory(data) || null
    const eventPriceAmount = eventGetters.getDefaultPriceAmount(data)
    const eventPrice = eventPriceAmount
      ? parseInt(String(eventPriceAmount)) / 100
      : 0

    return {
      item_id: eventId,
      item_name: eventTitle,
      item_category: category,
      item_brand: partnerName,
      price: eventPrice.toFixed(2),
      google_business_vertical: 'custom',
    }
  }

  // Handle AlgoliaEventItem (from Algolia search)
  const eventTitle = algoliaEventGetters.fnGetTitle(data)
  const eventId = algoliaEventGetters.fnGetHashedId(data)
  const partnerName = algoliaEventGetters.fnGetSupplier(data)
  const category = algoliaEventGetters.fnGetMainCategory(data)
  const eventPrice = algoliaEventGetters.getPriceAmount(data)

  return {
    item_id: eventId,
    item_name: eventTitle,
    item_category: category,
    item_brand: partnerName,
    price: (eventPrice / 100).toFixed(2),
    google_business_vertical: 'custom',
  }
}
